const userTypes = (intl) => {
  const userType = [
    { 
      label: intl.formatMessage({ id: "EXHIBITOR" }), 
      value: 1,
      optionName: "EXHIBITOR"
    },
    { 
      label: intl.formatMessage({ id: "SPONSOR_WITHOUT_M2" }), 
      value: 19,
      optionName: "SPONSOR_WITHOUT_M2"
    },
    { 
      label: intl.formatMessage({ id: "DIGITAL_ONLY" }), 
      value: 20,
      optionName: "DIGITAL_ONLY"
    },
  ];

  return userType;
};

export default userTypes;
